import _sortBy from 'lodash.sortby';
import { isEmpty, isPresent } from '@ember/utils';
import ArrayProxy from '@ember/array/proxy';
import TemplateModel from 'cio/models/template';

export function getDefaultTemplates(templates: TemplateModel[] | ArrayProxy<TemplateModel>): TemplateModel[] {
  return (templates ?? []).filter((template: TemplateModel) => isEmpty(template.language));
}

export function getDefaultTemplateForTestGroup(
  testGroupId: string,
  templates: TemplateModel[] | ArrayProxy<TemplateModel>,
): TemplateModel | undefined {
  return templates.find((template) => isEmpty(template.language) && template.testGroupId === testGroupId);
}

export function getTestGroupTemplates(
  testGroupId: string,
  templates: TemplateModel[] | ArrayProxy<TemplateModel>,
): TemplateModel[] {
  return templates.filter((template) => template.testGroupId === testGroupId);
}

export function getTranslationTemplatesForTestGroup(
  testGroupId: string,
  templates: TemplateModel[] | ArrayProxy<TemplateModel>,
): TemplateModel[] {
  return _sortBy(
    templates.filter((template) => {
      return isPresent(template.language) && template.testGroupId === testGroupId;
    }),
    ['language'],
  );
}

export function getTestGroupIds(templates: TemplateModel[] | ArrayProxy<TemplateModel>) {
  let ids = new Set<string>();
  templates.forEach((template) => ids.add(String(template.testGroupId)));
  return [...ids];
}
